export interface LatLng {
  lat: number
  lng: number
  srid?: string
}

export const METER_TO_DEGREE = 0.00001
export const DEGREE_TO_METER = 100000
export const DEFAULT_LAYER_SIZE = 3

export interface Location {
  prefCode: string
  cityCode: string
  areaCode: string
  streetCode: string
  prefName: string
  cityName: string
  areaName: string
  streetName: string
  blockNumber: string
  houseNumber: string
  katagaki: string
  branch: string
  location: LatLng
  quadkey: string
}

export interface Geometry {
  type: string
  coordinates: number[][][][]
}
